/* eslint no-eval: 0 */
import React, { useState, useEffect } from 'react';
import { Button, Col, Progress, Row } from 'antd';
import Baloons from '../../base/Baloons';
import Result from '../../base/result';
import { getSeriesFromCouples } from '../../../utils';
import { motion } from 'framer-motion';
import { t } from '../../../languages';
import moment from 'moment';

import './index.less';
import { getRandomMessage2, getSumSubSeries } from '../utils';
import BackMusic from '../../base/BackMusic';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';

const BaloonSchall = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        message: null,
        message2: null,
        showresults: false,
        levels: [],
    });
    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        handleRepeat();
    }, []);

    const handleRate = (isgood, timereq) => {
        const { current, series, results, times } = state;
        let currentNumber = '' + series[current];
        const value = Math.floor(eval(currentNumber));
        const ops = currentNumber.match(/(\+|-|\*|\/)/sg);

        currentNumber = currentNumber.replace('*', ' x ').replace('/', ' ÷ ').replace('+', ' + ').replace('-', ' - ');
        const ops_result = ops ? ` ${currentNumber} = ${value}` : '';

        const message = isgood ? `${t(props.lang, 'rightanswer')}: ${ops_result}` : `${t(props.lang, 'wrong')},  ${ops_result}`;
        const message2 = isgood && timereq ? t(props.lang, getRandomMessage2('great')) : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            times: [...times, timereq],
            results: [...results, isgood],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series, results, times } = state;

        if (current < series.length - 1) {
            setState((prevState) => ({
                ...prevState,
                current: current + 1,
                message: null,
                message2: null,
                ready: false,
            }));
        } else {
            const { params, uid, eid, saveResult } = props;
            const num = state.levels.length;
            const hits = results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;

            const is_test = params.is_test ? params.is_test : false;
            const totalTime = times.reduce((acc, aT) => acc + aT, 0);
            const elapsedTime = moment().diff(initMoment, 'seconds');

            saveResult(uid, `${uid}-${eid}`, { id: 'BC', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, t: totalTime, r: results, s: series, et: elapsedTime }, times);

            if (!is_test) {
                setState((prevState) => ({
                    ...prevState,
                    showresults: true,
                }));
            }
        }
    };

    const handleRepeat = () => {
        const { couples, levels, init, finish, ops, config, ispan, fspan } = props.params;
        props.params.num = levels.length;

        // const series = getSeriesFromCouples(couples, levels.length, init, finish, ops, config, ispan, fspan);
        const series = getSumSubSeries(props.params);

        const levelsArray = levels || [];

        setState({
            series,
            current: 0,
            results: [],
            times: [],
            message: null,
            message2: null,
            showresults: false,
            ready: false,
            levels: levelsArray,
        });
    };

    const handleComplete = (isgood, timereq) => {
        // console.log('handleComplete:', isgood, timereq);
        handleRate(isgood, timereq);

        /* For competitions */
        const sendResultsOnComplete = props.params.sendResultsOnComplete || false;
        if (sendResultsOnComplete) {
            const { uid, eid, saveResult } = props;
            saveResult(uid, `${uid}-${eid}`, { id: 'BC', uid, eid, p: isgood }, timereq);
        }
    };

    const {
        current,
        series,
        results,
        message,
        message2,
        showresults,
        levels,
    } = state;

    const level = levels[current];
    const currentNumber = series[current];
    const value = currentNumber ? Math.floor(eval('' + currentNumber)) : null;

    const formattedNumber = currentNumber ? new String(currentNumber)
        .replace('*', ' x ')
        .replace('/', ' ÷ ')
        .replace('+', ' + ')
        .replace('-', ' - ')
        : null;

    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / series.length) * 100);
    const is_test = props.params.is_test ? props.params.is_test : false;

    /* For competitions */
    const showSolution = props.params.showSolution || false;
    const hideNextButton = props.params.hideNextButton || false;

    if (!showresults) {
        if (!level) return null;

        return (
            <Row className="exercise">
                <BackMusic source={'random'} />

                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}

                <Col span={24} className="exercise-body baloons-body">
                    <section className="baloonschall">
                        <article className="baloons">
                            {message ? <ExerciseBlocker show={messagestyle || showSolution} /> : null}
                            <Baloons
                                key={current}
                                items={level.num - 1}
                                rows={props.params.rows}
                                value={value}
                                vel={level.vel}
                                init={props.params.init}
                                finish={props.params.finish}
                                onComplete={handleComplete}
                                stop={showSolution}
                            />
                        </article>
                        {!message ? <article className="number" key={currentNumber}>
                            <motion.div
                                animate={{ scale: 2 }}
                                transition={{ duration: 1 }}
                                className="the-number"
                            >
                                {formattedNumber} {showSolution ? ` = ${value}` : null}
                            </motion.div>
                        </article> : null}
                        {message ? <Row className={`botones balloons${messagestyle}`}>
                            <Col span={24} className="message">
                                {message}
                            </Col>

                            {message && !hideNextButton && (
                                <Col span={24}>
                                    <Button key="submit" type="primary" onClick={handleNext} style={{ width: '90%' }} > {t(props.lang, 'next')}</Button>
                                </Col>
                            )}
                            {message2 && !hideNextButton && (
                                <Col span={24} className="message">
                                    {message2}
                                </Col>
                            )}
                        </Row> : null}
                    </section>
                </Col>

            </Row >
        );
    } else {
        const params = { ...props.params, num: series.length, show_time: true };

        return (
            <Result params={params} results={results} handleRepeat={handleRepeat} handleCancel={props.handleCancel} lang={props.lang} />
        );
    }
};

export default BaloonSchall;